import serverCheck from "../../modules/serverCheck";
import BaseService from "../BaseService";

class UserService extends BaseService {
  baseUrl = `${
    serverCheck.getServer().serverTmsAdmin
  }/TableData/V1/userListOptions`;
  cacheOptions = {
    prefix: "tms-users",
    ttl: 1 // 1 minute
  };

  async list() {
    const res = await this.httpClient.get("/");
    return res.data.data;
  }
}

const userService = new UserService();

export default userService;
